import {ReactElement, useState} from "react";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {DataGridPremium, GridColDef} from "@mui/x-data-grid-premium";
import {useGetCurrencyCross, useSyncCurrencyCross} from "../../application/CurrencyCrossService";
import SnackbarComponent, {defaultSnackbarState, SnackbarState} from "../../components/SnackbarComponent";
import {RefreshDataFunction} from "../../components/types/RefreshDataFunction";
import {Statistics} from "../../domain/staticdata/Statistics";
import {useAutoSizeGrid} from "../../components/AutoSizeGridHook";
import {CurrencyCross} from "../../domain/staticdata/CurrencyCross";
import RefreshStaticComponent from "../../components/RefreshStaticComponent";

export default function CurrencyCrosses(): ReactElement {
    const { data, loading , apiFunction} = useGetCurrencyCross();
    const [ snackbarState, setSnackbarState ] = useState<SnackbarState>(defaultSnackbarState);
    const syncCurrencyCross: RefreshDataFunction<Statistics> = useSyncCurrencyCross();
    const apiRef = useAutoSizeGrid<CurrencyCross>({
        data: data,
        loading: loading,
        columns: [
            'id',
            'decimals',
            'invert'
        ]
    })

    const initialState =
        {
            columns: {
                columnVisibilityModel: {
                },
                dimensions: {
                    id: { width: 250 },
                    decimals: { width: 240 },
                    invert: { flex: 1 },
                }
            }
        }

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id'},
        { field: 'decimals', headerName: 'Decimals' },
        { field: 'invert', headerName: 'Invert'}
    ];

    return (
        <Container maxWidth={ false } sx={{mt: 4, mb: 4}}>
            {<Toolbar/>}
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                <Grid size={{ xs: 12, md: 10, lg: 10 }}>
                    <Title>Currency Cross</Title>
                </Grid>
                <RefreshStaticComponent refreshFunction={ syncCurrencyCross } dataFunction={ apiFunction } setSnackbarState={ setSnackbarState }/>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ height: 1000 }}>
                    <DataGridPremium
                        apiRef={apiRef}
                        initialState={initialState}
                        showToolbar
                        loading={loading}
                        rows={data}
                        columns={columns}
                        density={"compact"}
                    />
                </Grid>
            </Grid>
            <SnackbarComponent setState={ setSnackbarState} state={ snackbarState}/>
        </Container>
    );
}